// extracted by mini-css-extract-plugin
export default {"container":"_F-z","dimension":"aG-z","dimensionLabels":"bG-z"};